// @flow
import React, { Component, Fragment } from 'react';
import { getScrollTop } from 'lib/common';
import { MdClose, MdLink, MdShare } from 'react-icons/md';
import { FaFacebookSquare, FaHeart, FaRegHeart, FaTwitter } from 'react-icons/fa';

import Tooltip from 'react-tooltip';
import withClickOutside from 'react-onclickoutside';

import cx from 'classnames';
import { copyText, shareFacebook, shareTwitter } from 'lib/share';
import './QuoteLeftSticker.scss';

type Props = {
  likes: number,
  liked: boolean,
  onToggleLike: () => void,
  informCopy: () => void,
  logged: boolean,
  url: string,
  title: string,
  username: string,
  disabled: boolean,
};

type State = {
  fixed: boolean,
  openShare: boolean,
  justLiked: boolean,
};

class QuoteLeftSticker extends Component<Props, State> {
  pos: number = 0;
  element = React.createRef();
  state = {
    fixed: false,
    openShare: false,
    justLiked: false,
  };
  handleClickOutside = () => {
    if (!this.state.openShare) return;
    this.onToggleShareButton();
  };

  componentDidMount() {
    if (!this.element.current) return;
    this.pos = this.element.current.getBoundingClientRect().top + getScrollTop();
    window.addEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    const scrollTop = getScrollTop();
    const fixed = scrollTop >= this.pos;
    if (this.state.fixed !== fixed) {
      this.setState({ fixed });
    }
  };
  onToggleShareButton = () => {
    this.setState({
      openShare: !this.state.openShare,
    });
  };
  onFacebookShare = () => {
    this.onToggleShareButton();
    shareFacebook(`${process.env.BASE_URL}${this.props.url}`);
  };
  onTwitterShare = () => {
    this.onToggleShareButton();
    shareTwitter(
      `${process.env.BASE_URL}${this.props.url}`,
      `${this.props.username}가 등록한 "${this.props.title}" 견적요청를 둘러보세요.`,
    );
  };
  onCopy = () => {
    this.onToggleShareButton();
    copyText(`${process.env.BASE_URL}${this.props.url}`);
    this.props.informCopy();
  };

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.liked && this.props.liked) {
      this.setState({
        justLiked: true,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  render() {
    const { likes, liked, logged, onToggleLike, disabled } = this.props;
    const { fixed, openShare, justLiked } = this.state;
    return (
      <div className="QuoteLeftSticker" ref={this.element}>
        <div className={cx('wrapper', { fixed })}>
          <button
            onClick={disabled ? undefined : onToggleLike}
            className={cx('circle like', { liked, disabled, justLiked: liked && justLiked })}
            {...(disabled ? { 'data-tip': '로그인 후 이용해주세요.' } : {})}
          >
            {liked ? <FaHeart /> : <FaRegHeart />}
          </button>
          <div className="likes-count">{likes}</div>
          <button className="circle share" onClick={this.onToggleShareButton}>
            {openShare ? <MdClose /> : <MdShare />}
          </button>
          {openShare && (
            <Fragment>
              <button className="circle share" onClick={this.onFacebookShare}>
                <FaFacebookSquare />
              </button>
              <button className="circle share" onClick={this.onTwitterShare}>
                <FaTwitter />
              </button>
              <button className="circle share" onClick={this.onCopy}>
                <MdLink />
              </button>
            </Fragment>
          )}
        </div>
        <Tooltip effect="solid" className="tooltip" />
      </div>
    );
  }
}

export default withClickOutside(QuoteLeftSticker);



// WEBPACK FOOTER //
// ./src/components/quote/QuoteLeftSticker/QuoteLeftSticker.js